const translations = {
  common: {
    search: '搜索',
    searching: '搜索中',
    signIn: '登录',
    register: '注册',
    myAccount: '我的账户',
    support: '支持',
    followUs: '在X/Twitter上关注我们',
    proMembership: 'Pro会员',
    new: '新',
    proMember: 'Pro会员',
    upgrade: '升级',
    subscribe: '订阅',
    manage: '管理',
    cancel: '取消',
    close: '关闭',
    or: '或',
    email: '电子邮件地址',
    continue: '继续',
    submit: '提交',
    billing: '账单',
    sort: '排序',
    language: '语言',
    selectLanguage: '选择语言',
    searchPlaceholder: '搜索...',
    cards: '卡牌',
    previous: '上一页',
    next: '下一页',
    pagination: '分页',
    back: '返回',
    backToSets: '返回系列',
    error: '发生错误。请重试。',
    home: '首页',
    sets: '系列',
    login: '登录',
    loginRequired: '请登录以访问此功能',
    adding: '添加中...',
  },
  languages: {
    default: '默认',
    any: '任意',
    english: '英语',
    spanish: '西班牙语',
    french: '法语',
    german: '德语',
    italian: '意大利语',
    portuguese: '葡萄牙语',
    japanese: '日语',
    korean: '韩语',
    russian: '俄语',
    simplified_chinese: '简体中文',
    traditional_chinese: '繁体中文',
    hebrew: '希伯来语',
    latin: '拉丁语',
    ancient_greek: '古希腊语',
    arabic: '阿拉伯语',
    sanskrit: '梵语',
    phyrexian: '非瑞克西亚语',
    quenya: '昆雅语',
  },
  filters: {
    show: '✨ 显示Pro过滤器',
    hide: '✨ 隐藏Pro过滤器',
  },
  pages: {
    search: {
      heading: 'MTG卡牌搜索',
    },
    sets: {
      heading: '卡牌系列',
      latestSets: '最新系列',
      upcomingSets: '即将推出的系列',
      allSets: '所有系列',
      noResults: '未找到结果。',
    },
    set: {
      notFound: '未找到系列。',
      noCards: '此系列中未找到卡牌。',
      addAll: '将 {{count}} 张卡牌添加到代理列表',
      addedToList: '已将 {{count}} 张卡牌添加到代理列表',
    },
    tokens: {
      heading: '衡生物',
    },
    emblems: {
      heading: '徽记',
    },
    import: {
      heading: '导入卡牌到代理列表',
      description: '输入您想添加到代理列表的所有卡牌名称。',
    },
    topProxies: {
      heading: '热门代理',
      description: '以下是TCG Stacked上最受欢迎的50张MTG代理卡牌。',
    },
  },
  theme: {
    light: '浅色',
    dark: '深色',
    toggle: '切换主题',
  },
  cta: {
    title: '准备好开始了吗？',
    subtitle: '今天就开始代理卡牌。',
    searchByCard: '按卡牌搜索',
    searchBySet: '按系列搜索',
  },
  nav: {
    magicTheGathering: 'Magic: The Gathering',
    pokemon: '宝可梦',
    sets: '系列',
    tokens: '衡生物',
    emblems: '徽记',
    import: '导入',
    topProxies: '热门代理',
    customCards: '自定义卡牌',
    deckBuilder: '套牌构建器',
    buildDeck: '构建套牌',
    publicDecks: '公开套牌',
    favoriteDeck: '我的收藏套牌',
    articles: '文章',
    feedback: '分享反馈',
    collection: '我的收藏',
    pokemonSets: '宝可梦系列',
    pokemonSearch: '搜索宝可梦卡牌',
  },
  seo: {
    collection: {
      title: '我的卡牌收藏 | TCG Stacked',
      description: '管理您的个人卡牌收藏。在一个地方追踪、组织和评估您的万智牌卡牌。',
    },
    home: {
      title: 'TCG Stacked - 集换式卡牌游戏代理卡牌',
      description: '访问庞大的集换式卡牌游戏代理卡牌库。轻松查看和打印卡牌图片用于休闲游戏。现在就开始构建你梦想中的套牌！',
    },
    sets: {
      title: '卡牌系列 - TCG Stacked',
      description: '浏览所有卡牌系列并打印套牌用的代理卡牌。',
    },
    tokens: {
      title: '衡生物 - TCG Stacked',
      description: '使用各种代理衡生物增强你的游戏体验。',
    },
    emblems: {
      title: '徽记 - TCG Stacked',
      description: '打印套牌用的徽记代理卡牌。',
    },
    search: {
      title: '卡牌搜索 - TCG Stacked',
      description: '轻松查找和打印代理卡牌。使用搜索工具访问庞大的数据库，用代理卡牌增强你的套牌。',
    },
    support: {
      title: '支持 - TCG Stacked',
      description: '如果你有问题、反馈或想要添加衡生物/徽记，请发送电子邮件给我们。',
    },
    articles: {
      title: '文章 - TCG Stacked',
      description: '关于集换式卡牌游戏和代理卡牌的文章。',
    },
    import: {
      title: '导入 - TCG Stacked',
      description: '导入卡牌列表以打印代理卡牌。',
    },
    topProxies: {
      title: '热门代理 - TCG Stacked',
      description: '查看TCG Stacked上最受欢迎的代理卡牌。',
    },
    customCards: {
      title: '自定义卡牌 - TCG Stacked',
      description: '创建你自己的集换式卡牌游戏代理卡牌。',
    },
    login: {
      title: '登录 - TCG Stacked',
      description: '登录你的账户以管理自定义卡牌、套牌列表等。',
    },
    register: {
      title: '注册 - TCG Stacked',
      description: '注册账户以管理自定义卡牌、套牌列表等。',
    },
    termsOfService: {
      title: '服务条款 - TCG Stacked',
      description: '阅读网站的服务条款。',
    },
    privacyPolicy: {
      title: '隐私政策 - TCG Stacked',
      description: '阅读网站的隐私政策。',
    },
    account: {
      title: '账户 - TCG Stacked',
      description: '管理你的账户。',
    },
    proMembership: {
      title: 'Pro会员 - TCG Stacked',
      description: '订阅Pro会员以访问网站的所有功能。',
    },
    deckBuilder: {
      title: '套牌构建器 - TCG Stacked',
      description: '创建和管理你的集换式卡牌游戏套牌。',
    },
    deckEditor: {
      title: '套牌编辑器 - TCG Stacked',
      description: '创建和编辑你的集换式卡牌游戏套牌。',
    },
    publicDecks: {
      title: '公开套牌 - TCG Stacked',
      description: '浏览和探索社区分享的公开套牌。',
    },
  },
  pro: {
    pricing: {
      title: '解锁Pro卡牌代理制作',
      subtitle: '升级到Pro会员以获得无广告的卡牌代理制作和所有功能与福利。',
      monthlyPlan: '月度Pro会员',
      yearlyPlan: '年度Pro会员',
      monthlyPrice: '$5.00/月',
      yearlyPrice: '$40.00/年',
      subscribeMonthly: '月度订阅',
      subscribeYearly: '年度订阅',
      signInToSubscribe: '登录以订阅',
      manageSubscription: '管理订阅',
      nextBillingDate: '下次账单日期',
      benefitsEndDate: '福利结束日期',
      viewInvoice: '查看发票',
      changePlan: '更改计划',
      reactivate: '重新激活',
      active: '活跃',
      cancelled: '已取消',
      freeTrial: '免费试用',
      freeTrialEnds: '免费试用结束',
      startFreeTrial: '开始7天免费试用',
      signInForFreeTrial: '登录以获取7天免费试用',
      subscribe: '立即订阅',
      current: '当前',
    },
    benefits: {
      title: '为什么需要TCG Stacked Pro会员',
      subtitle: '加入数百名玩家的行列，他们通过这些独家Pro功能提升了MTG的体验！',
      noAds: {
        title: '无广告',
        description: '浏览和制作代理卡牌时没有烦人的广告、横幅和弹窗。享受干净、专注的体验。',
      },
      darkMode: {
        title: '深色模式',
        description: '使用优雅的深色界面减少眼睛疲劳。完美适合夜间浏览和低光环境。',
      },
      advancedSearch: {
        title: '高级搜索过滤器',
        description: '访问强大的搜索过滤器以精确找到你需要的卡牌。按颜色身份、稀有度和卡牌类型过滤。',
      },
      multipleDecks: {
        title: '多套牌管理',
        description: '使用套牌构建器创建和管理多个套牌。保存所有收藏的套牌以快速访问。',
      },
      futureFeatures: {
        title: '未来Pro功能',
        description: '在新的高级功能发布时立即访问。Pro会员总是优先获得访问权。',
      },
      cancelAnytime: {
        title: '随时取消',
        description: '无需长期承诺。你可以灵活地随时取消订阅。',
      },
      prioritySupport: {
        title: '优先支持',
        description: '使用专属优先支持跳过等待队列。你的问题和疑虑将优先得到特别关注。',
      },
    },
    features: {
      unlimitedDecks: '无限套牌创建',
      noAds: '无广告',
      prioritySupport: '优先支持',
      darkMode: '深色模式访问',
      advancedSearch: '高级搜索过滤器',
    },
    promotion: {
      title: '升级到Pro以创建更多套牌',
      description: 'Pro会员可以创建无限数量的套牌。立即升级以解锁此功能！',
      customizeTitle: 'Pro功能：AI卡牌定制',
      customizeDescription: '升级到Pro以使用AI创建自定义卡牌变体。Pro会员每天可以生成最多5张自定义卡牌。',
    },
    account: {
      title: 'Pro会员',
      description: '管理您的高级会员权益',
      subscribeToPro: '订阅Pro会员',
    },
  },
  auth: {
    signIn: {
      title: '登录你的账户',
      withGoogle: '使用Google继续',
      withEmail: '或使用以下方式继续',
      sendMagicLink: '发送魔法链接',
      noAccount: '没有账户？',
      checkEmail: '检查你的电子邮件中的登录链接',
      errors: {
        failed: '登录失败',
        failedGoogle: 'Google登录失败',
        failedEmail: '电子邮件登录失败',
        noEmail: '未找到电子邮件',
      },
      terms: '登录即表示你同意：',
    },
    register: {
      title: '创建账户',
      haveAccount: '已有账户？',
      terms: '创建账户即表示你同意：',
    },
    common: {
      termsOfService: '服务条款',
      privacyPolicy: '隐私政策',
      and: '和',
    },
  },
  home: {
    hero: {
      title: '代理卡',
      rotatingWords: ['卡牌', '衡生物', '徽记', '鹏洛客', '指挥官', '地', '生物', '神器', '结界', '瞬间'],
      description: 'TCG Stacked帮助您免费制作集换式卡牌游戏代理卡，供您在休闲套牌中使用！',
      search: {
        cards: {
          tab: '卡牌',
          placeholder: '搜索集换式卡牌游戏卡牌...',
          error: '加载随机卡牌失败',
        },
        sets: {
          tab: '系列',
          placeholder: '搜索集换式卡牌游戏系列...',
        },
        tokens: {
          tab: '衡生物',
          placeholder: '搜索万智牌衡生物...',
        },
        button: '搜索',
        hint: {
          cards: '按回车键或点击搜索以查找卡牌',
          sets: '按回车键或点击搜索以查找系列',
          tokens: '按回车键或点击搜索以查找衡生物',
        },
        aria: {
          searchIcon: '搜索图标',
          searchInput: {
            cards: '搜索卡牌',
            sets: '搜索系列',
            tokens: '搜索衡生物',
          },
        },
      },
      images: {
        cardAlt: '万智牌卡牌图片',
      },
      processedCount: '🎉 我们已为社区处理了超过 {{count}} 张免费代理卡！ 🎉',
    },
    features: {
      section1: {
        badge: '打印代理卡',
        title: '打印MTG代理卡',
        subtitle: '将卡牌添加到打印列表，打印出来，今天就可以在您的套牌中使用！',
        features: [
          {
            name: '添加卡牌到打印列表',
            description: '使用搜索页面查找任何卡牌，或浏览系列并将您想要的卡牌添加到打印列表。',
          },
          {
            name: '打印卡牌',
            description: '将所有想要的卡牌添加到打印列表后，您可以打印它们并在套牌中使用。',
          },
          {
            name: '在套牌中使用',
            description: '打印卡牌后，您可以在套牌中使用它们。将它们剪下并贴在基本地上，或使用装有基本地的卡套。',
          },
        ],
        images: {
          cartScreenshot: '展示如何将卡牌添加到打印列表的购物车截图',
        },
      },
      section2: {
        badge: '套牌构建器',
        title: '构建和管理万智牌套牌',
        subtitle: '创建和管理您自己的套牌，或浏览社区创建的公开套牌。',
        features: [
          {
            name: '管理您的MTG套牌',
            description: '所有用户都可以创建和管理一副MTG套牌。Pro会员可以创建无限数量的套牌。',
          },
          {
            name: '打印卡牌',
            description: '将所有想要的卡牌添加到套牌后，您可以一次性将它们全部添加到打印列表。',
          },
          {
            name: '浏览公开套牌',
            description: '将社区创建的完整套牌添加到您的打印列表，轻松测试新套牌。',
          },
        ],
        images: {
          deckBuilderScreenshot: '展示如何管理套牌的套牌构建器界面',
        },
      },
    },
  },
  sort: {
    nameAsc: '名称 (A 到 Z)',
    nameDesc: '名称 (Z 到 A)',
    cmcAsc: '法术力费用 (从低到高)',
    cmcDesc: '法术力费用 (从高到低)',
    usdAsc: '价格 (从低到高)',
    usdDesc: '价格 (从高到低)',
    rarityAsc: '稀有度 (普通到神话)',
    rarityDesc: '稀有度 (神话到普通)',
    releasedDesc: '发行日期 (最新)',
    releasedAsc: '发行日期 (最早)',
  },
  pages: {
    search: {
      heading: '搜索',
    },
    sets: {
      heading: '卡牌系列',
      latestSets: '最新系列',
      upcomingSets: '即将发布系列',
      allSets: '所有系列',
      noResults: '未找到结果。',
    },
    set: {
      notFound: '未找到系列。',
      noCards: '未在此系列中找到卡牌。',
      addAll: '将{{count}}张卡牌添加到打印列表',
      addedToList: '已将{{count}}张卡牌添加到打印列表',
    },
    tokens: {
      heading: '衡生物',
    },
    emblems: {
      heading: '徽记',
    },
    import: {
      heading: '导入卡牌到打印列表',
      description: '输入你想添加到打印列表的所有卡牌名称。',
    },
    topProxies: {
      heading: '热门代理',
      description: '以下是MTG Proxies上最受欢迎的50张万智牌代理卡牌。',
    },
  },
  languages: {
    default: '默认',
    any: '任意',
    english: '英语',
    spanish: '西班牙语',
    french: '法语',
    german: '德语',
    italian: '意大利语',
    portuguese: '葡萄牙语',
    japanese: '日语',
    korean: '韩语',
    russian: '俄语',
    simplified_chinese: '简体中文',
    traditional_chinese: '繁体中文',
    hebrew: '希伯来语',
    latin: '拉丁语',
    ancient_greek: '古希腊语',
    arabic: '阿拉伯语',
    sanskrit: '梵语',
    phyrexian: '非瑞克西亚语',
    quenya: '昆雅语',
  },
  filters: {
    show: '✨ 显示专业版筛选',
    hide: '✨ 隐藏专业版筛选',
  },
  search: {
    showing_start: '显示第',
    showing_to: '到第',
    showing_of: '条，共',
    showing_results: '条结果',
    noResults: '未找到结果。',
    useSearchTip: '使用页面顶部的搜索来查找卡牌。',
  },
  footer: {
    copyright: 'TCG Stacked，保留所有权利。',
    disclaimer: 'TCG Stacked 并非由任何集换式卡牌游戏出版商制作、认可、支持或附属。',
    affiliate: '作为 TCGplayer 的联盟合作伙伴，TCG Stacked 可能会从合格购买中获得佣金。',
    builtBy: '开发者',
    minnerLabs: 'Minner Labs',
    privacyPolicy: '隐私政策',
    termsOfService: '服务条款',
    support: '支持',
  },
  advancedFilters: {
    colors: '颜色',
    rarity: '稀有度',
    cardTypes: '卡牌类型',
    format: '赛制',
    manaValue: '法术力值',
    cardName: '卡牌名称',
    cardText: '卡牌文本',
    specialCharacteristics: '特殊特性',
    activeFilters: '激活的筛选条件',
    clearAll: '全部清除',
    applyFilters: '应用筛选',
    searchCardName: '搜索卡牌名称...',
    searchCardText: '搜索卡牌文本...',
    namePrefix: '名称：',
    manaPrefix: '法术力：',
    textPrefix: '文本：',
    removeFromFilter: '✕',
    selectLanguage: '选择语言',
  },
  card: {
    addToPrintList: '添加到打印列表',
    removeFromPrintList: '从打印列表中移除',
    cardsInPrintList: '张卡牌在打印列表中',
    cardsInPrintListPlural: '张卡牌在打印列表中',
    buyOn: '在TCGplayer上购买',
    buyFor: '购买价格：',
    viewDetails: '查看详情',
    type: '类型',
    manaCost: '法术力费用',
    rarity: '稀有度',
    artist: '画师',
    collectorNumber: '收藏编号',
    oracleText: '神谕文本',
    youMightAlsoLike: '你可能也喜欢...',
    noRecommendations: '暂无推荐。',
    details: '详情',
    rulings: '规则',
    legality: '合法性',
    share: '分享',
    favorite: '收藏',
    noRulings: '此卡牌暂无规则。',
    noLegalityInfo: '此卡牌暂无合法性信息。',
    published: '发布',
    legal: '合法',
    restricted: '受限',
    banned: '禁用',
    format: '赛制',
    status: '状态',
    viewMore: '查看更多',
    viewLess: '收起',
    customizeWithAI: '使用AI自定义',
    otherVersions: '独特印刷',
    showUniqueVersions: '显示独特印刷',
    hideUniqueVersions: '隐藏独特印刷',
  },
  cart: {
    title: '打印列表',
    closePanel: '关闭面板',
    empty: '打印列表中没有代理卡。',
    addPadding: '添加边距',
    paperSize: '纸张大小',
    scale: '缩放',
    clearCardList: '清空列表',
    print: '打印',
    success: '成功！',
  },
  setsList: {
    showing: '显示',
    to: '至',
    of: '/',
    results: '个结果',
    searchPlaceholder: '搜索...',
  },
  customizeCardModal: {
    title: '使用AI自定义卡牌',
    description: '描述您希望如何自定义这张卡牌。AI将生成一个新版本，同时保持卡牌框架和结构。',
    buttonText: '使用AI自定义',
    placeholder: '描述您的自定义卡牌变体...',
    generateButton: '生成自定义卡牌',
    generatingButton: '生成中...',
    addToPrintListButton: '添加到打印列表',
    successMessage: '自定义卡牌已添加到打印列表',
    remainingGenerationsOne: '本月还剩{{count}}次生成机会',
    remainingGenerationsOther: '本月还剩{{count}}次生成机会',
    error: {
      failed: '生成自定义卡牌失败',
    },
  },
  collection: {
    title: '我的收藏',
    loginRequired: '需要登录',
    loginMessage: '请登录以查看您的收藏',
    emptyCollection: '未找到卡牌',
    emptyCollectionMessage: '您的收藏为空。从卡牌详情页面添加卡牌或使用批量添加功能。',
    noMatchingCards: '没有匹配的卡牌。',
    searchPlaceholder: '搜索卡牌...',
    sortBy: '排序方式',
    sortName: '名称',
    sortPrice: '价格',
    sortDate: '添加日期',
    sortQuantity: '数量',
    filterRarity: '稀有度',
    filterSet: '系列',
    allRarities: '所有稀有度',
    allSets: '所有系列',
    filters: '筛选器',
    clearFilters: '清除筛选',
    sortAscending: '升序排列',
    sortDescending: '降序排列',
    bulkAdd: '批量添加',
    bulkAddTitle: '从打印列表添加卡牌',
    bulkAddDescription: '将所有打印列表中的卡牌添加到您的收藏中。',
    addToCart: '添加到打印列表',
    addedToCart: '已添加到打印列表',
    stats: '统计信息',
    totalValue: '总价值',
    filteredValue: '筛选后的价值',
    cardCount: '卡牌数量',
    totalCards: '总卡牌数',
    uniqueCards: '独特卡牌数',
    filteredCards: '筛选后的卡牌数',
    rarityBreakdown: '稀有度分布',
    export: '导出收藏',
    exporting: '导出中...',
    exportSuccess: '成功导出收藏',
    exportError: '导出收藏失败',
    noCardsToExport: '没有要导出的卡牌',
    exportCardName: '卡牌名称',
    exportSet: '系列',
    exportRarity: '稀有度',
    exportQuantity: '数量',
    exportPrice: '价格',
    exportTotalValue: '总价值',
    exportDateAdded: '添加日期',
    // Quick add feature
    quickAdd: '快速添加',
    searchCards: '搜索要添加的卡牌',
    typeToSearch: '输入至少3个字符进行搜索',
    noResults: '未找到结果',
    noCardSelected: '未选择卡牌',
    addCardToCollection: '将卡牌添加到收藏',
    addCardDescription: '指定要添加到收藏的数量',
    quantity: '数量',
    price: '价格',
    // Insights
    insights: '收藏分析',
    noInsightsAvailable: '您的收藏没有可用的分析信息',
    insightsDescription: '关于您收藏的详细统计信息',
    rarityDistribution: '稀有度分布',
    topSets: '热门系列',
    priceDistribution: '价格分布',
    // Clear collection feature
    clearCollection: '清除收藏',
    clearCollectionConfirmTitle: '清除整个收藏？',
    clearCollectionConfirmMessage: '此操作无法撤消。您收藏中的所有卡牌将被永久删除。',
    // Edit card in collection
    editCardInCollection: '编辑收藏中的卡牌',
    editCardDescription: '更新收藏中此卡牌的详细信息。',
    viewCardDetails: '查看卡牌详情',
    condition: '状态',
    selectCondition: '选择状态',
    language: '语言',
    selectLanguage: '选择语言',
    finish: '完成度',
    selectFinish: '选择完成度',
    purchasePrice: '购买价格',
    isProxy: '这是一个代理卡',
    saveChanges: '保存更改',
    removeCard: '移除卡牌',
    cardRemoved: '卡牌已从收藏中移除',
    errorRemovingCard: '移除卡牌时出错',
    errorSavingChanges: '保存卡牌更改时出错',
    // Landing page
    landing: {
      title: '管理您的MTG收藏',
      description: '使用我们强大的收藏管理工具，在一个地方跟踪所有万智牌卡牌。',
      intro: '我们的收藏管理系统允许您轻松跟踪、组织和评估您的整个万智牌卡牌收藏。立即创建账户开始使用！',
      createAccount: '创建账户',
      getStarted: '立即开始',
      howItWorks: '如何使用',
      step1: '创建免费账户访问您的个人收藏',
      step2: '手动添加卡牌或从 CSV 文件导入',
      step3: '按系列、颜色、稀有度等组织卡牌',
      step4: '随时跟踪您收藏的价值',
      step5: '随时导出您的收藏数据',
    },
    features: {
      track: {
        title: '跟踪卡牌',
        description: '在一个地方管理所有万智牌卡牌的详细清单',
      },
      organize: {
        title: '按系列组织',
        description: '按系列、稀有度、颜色等对您的收藏进行排序和筛选',
      },
      value: {
        title: '监控价值',
        description: '一目了然地查看您整个收藏的当前市场价值',
      },
    },
  },
  feedback: {
    buttonLabel: '反馈',
    title: '分享您的反馈',
    description: '我们重视您的意见，以改进TCG Stacked。请与我们分享您的想法。',
    categoryLabel: '类别',
    categories: {
      bug: '错误报告',
      feature: '功能请求',
      improvement: '改进建议',
      general: '一般反馈',
      other: '其他',
    },
    messageLabel: '您的反馈',
    messagePlaceholder: '请分享您的想法、建议或报告问题...',
    ratingLabel: '评价您的体验（可选）',
    emailLabel: '电子邮件（可选）',
    emailPlaceholder: 'your@email.com',
    emailHelp: '如果您希望我们跟进，请提供您的电子邮件。',
    submitting: '提交中...',
    submitButton: '提交反馈',
    successMessage: '感谢您的反馈！',
    errorMessage: '提交反馈失败。请重试。',
  },
  customizeCardModal: {
    title: '使用AI自定义卡牌',
    description: '描述您希望如何自定义此卡牌。AI将生成一个新版本，同时保持卡牌框架和结构。',
    buttonText: '使用AI自定义',
    placeholder: '描述您的自定义卡牌变体...',
    generateButton: '生成自定义卡牌',
    generatingButton: '生成中...',
    addToPrintListButton: '添加到打印列表',
    successMessage: '自定义卡牌已添加到打印列表',
    remainingGenerationsOne: '本月剩余{{count}}次生成',
    remainingGenerationsOther: '本月剩余{{count}}次生成',
    promptIdeas: '快速提示创意',
    prompts: {
      fantasy: '将这张卡牌转变为高帝幻风格，添加魔法元素、闪光符文和空灵照明。保持卡牌框架不变，但使艺术作品看起来属于中世纪奇幻世界。',
      fantasyShort: '奇幻风格',
      scifi: '以未来科幻美学重新构想这张卡牌。添加生物机械元素、全息影显示屏和霓虹灯照的反乌托邦背景，同时保持原始卡牌结构。',
      scifiShort: '科幻风格',
      horror: '给这张卡牌一个黑暗、恐怖主题的改造，带有诡异的照明、令人不安的元素和恐怖的氛围。保持卡牌框架，但使艺术作品看起来属于恐怖场景。',
      horrorShort: '恐怖风格',
      anime: '以鲜艳的动漫艺术风格重新设计这张卡牌，带有大胆的色彩、动感的姿势和强烈的表现力。保持卡牌结构不变，但将艺术作品转变为动漫风格插图。',
      animeShort: '动漫风格',
      realistic: '使这张卡牌看起来逼真，带有详细的纹理、自然的照明和逐真的元素。保持卡牌框架，但将艺术作品转变为超写实的插图。',
      realisticShort: '写实风格',
      seasonal: '给这张卡牌一个带有当前季节元素的季节性改造。根据当前时间，添加秋叶、冬雪、春花或夏日阳光。',
      seasonalShort: '季节风格',
      steampunk: '以蒸汽朗克美学重新构想这张卡牌，带有黄铜齿轮、蒸汽驱动机器、维多利亚时代时装元素和工业革命氛围。',
      steampunkShort: '蒸汽朗克',
      chibi: '将这张卡牌转变为可爱的超变形风格，带有可爱的小型角色，大头和简化的特征，呈现迷人、有趣的外观。',
      chibiShort: '超变形风格',
      append: '确保保持卡牌框架、文本框和整体结构。只修改艺术作品。',
      appendButton: '添加框架保持文本',
    },
    error: {
      failed: '生成自定义卡牌失败',
    },
  },
  pages: {
    search: {
      heading: '搜索',
    },
    sets: {
      heading: '卡牌系列',
      latestSets: '最新系列',
      upcomingSets: '即将推出的系列',
      allSets: '所有系列',
      noResults: '未找到结果。',
    },
    set: {
      notFound: '未找到系列。',
      noCards: '此系列中未找到卡牌。',
      addAll: '将{{count}}张卡牌添加到打印列表',
      addedToList: '已将{{count}}张卡牌添加到打印列表',
    },
    tokens: {
      heading: '衡生物',
    },
    emblems: {
      heading: '徽记',
    },
    import: {
      heading: '将卡牌导入到打印列表',
      description: '输入您想添加到打印列表的所有卡牌名称。',
    },
    topProxies: {
      heading: '热门代理',
      description: '以下是TCG Stacked上最受欢迎的50张MTG代理卡牌。',
    },
  },
  mtg: {
    hero: {
      title: '代理',
      rotatingWords: ['卡牌', '地', '生物', '神器', '鹰洛客'],
      description: '搜索、浏览和创建万智牌集换式卡牌游戏的代理卡牌。',
      search: {
        cards: {
          tab: '卡牌',
          placeholder: '搜索任何MTG卡牌...',
          error: '获取随机MTG卡牌失败',
        },
        sets: {
          tab: '系列',
          placeholder: '搜索任何MTG卡牌系列...',
        },
        button: '搜索',
        hint: {
          cards: '按Enter键或点击搜索按钮查找您的卡牌',
          sets: '按Enter键或点击搜索按钮查找您的系列',
        },
        aria: {
          searchIcon: '搜索图标',
          searchInput: {
            cards: '搜索万智牌卡牌',
            sets: '搜索万智牌系列',
          },
        },
      },
      images: {
        cardAlt: '万智牌卡牌图片',
      },
      processedCount: '在我们的数据库中探索超过{{count}}张万智牌卡牌！',
    },
  },
  pokemon: {
    hero: {
      title: '代理',
      rotatingWords: ['卡牌', '宝可梦', '训练家', '能量', '竹斗场'],
      description: '搜索、浏览和创建宝可梦集换式卡牌游戏的代理卡牌。',
      search: {
        cards: {
          tab: '卡牌',
          placeholder: '搜索任何宝可梦卡牌...',
          error: '获取随机宝可梦卡牌失败',
        },
        sets: {
          tab: '系列',
          placeholder: '搜索任何宝可梦卡牌系列...',
        },
        button: '搜索',
        hint: {
          cards: '按Enter键或点击搜索按钮查找您的卡牌',
          sets: '按Enter键或点击搜索按钮查找您的系列',
        },
        aria: {
          searchIcon: '搜索图标',
          searchInput: {
            cards: '搜索宝可梦卡牌',
            sets: '搜索宝可梦系列',
          },
        },
      },
      images: {
        cardAlt: '宝可梦卡牌图片',
      },
      processedCount: '在我们的数据库中探索超过{{count}}张宝可梦卡牌！',
    },
    sets: {
      heading: '宝可梦卡牌系列',
      latestSets: '最新系列',
      upcomingSets: '即将推出的系列',
      allSets: '所有系列',
      noResults: '未找到结果。',
      sortBy: '排序方式',
      sort: {
        nameAsc: '名称 (A 到 Z)',
        nameDesc: '名称 (Z 到 A)',
        releaseDateDesc: '发布日期(最新在前)',
        releaseDateAsc: '发布日期(最旧在前)',
      },
      filterBy: '按系列筛选',
      allSeries: '所有系列',
    },
    set: {
      notFound: '未找到宝可梦系列。',
      backToSets: '返回系列',
      cards: '卡牌',
      released: '发布日期',
      noCards: '此系列中未找到卡牌。',
      tryAdjusting: '尝试调整您的搜索以找到您所需的内容。',
      sortBy: '排序方式',
      filterBy: '筛选方式',
      allTypes: '所有类型',
      allRarities: '所有稀有度',
      searchPlaceholder: '在此系列中搜索卡牌...',
    },
    card: {
      notFound: '未找到宝可梦卡牌。',
      backToSearch: '返回搜索',
      addToPrintList: '添加到打印列表',
      removeFromPrintList: '从打印列表中移除',
      inPrintList: '在打印列表中',
      buyOn: '在TCGplayer上购买',
      details: '详情',
      type: '类型',
      rarity: '稀有度',
      set: '系列',
      artist: '描绘者',
      number: '卡牌编号',
      flavorText: '剧情文本',
      attacks: '攻击',
      abilities: '能力',
      weakness: '弱点',
      resistance: '抵抗',
      retreatCost: '撤退消耗',
      legality: '合法性',
      otherVersions: '其他版本',
      youMightAlsoLike: '您可能也喜欢...',
    },
  },
  creditPurchaseModal: {
    title: '购买AI生成点数',
    description: '购买额外的AI生成点数以自定义更多卡牌。',
    buttonText: '购买点数',
    currentCredits: '当前点数',
    selectPackage: '选择点数套餐',
    purchase: '立即购买',
    noCreditsWarning: '没有可用点数',
    lowCreditsWarning: '剩余点数不足',
    buyCredits: '购买点数',
    remainingGenerationsOne: '{{count}} 点',
    remainingGenerationsOther: '{{count}} 点',
    creditPackages: {
      small: '小',
      medium: '中',
      large: '大',
    },
    loadingCredits: '加载点数信息...',
    valuePerCredit: '${value}/点',
    credits: '点数',
    failedCheckout: '创建结账会话失败',
  },

  // AI页面翻译
  ai: {
    pageTitle: '使用AI魔法自定义代理卡 | TCG Stacked',
    pageDescription: '用AI生成艺术改造您的万智牌卡牌。Pro会员专属功能。',
    hero: {
      badge: 'Pro功能',
      title: '使用AI魔法自定义代理卡',
      subtitle: '几秒钟内为您的万智牌代理卡创建自定义艺术图',
      cta: '免费试用Pro会员',
    },
    features: {
      title: '强大的AI功能触手可及',
      subtitle: '我们的AI自定义功能让您对万智牌代理卡拥有完全的创意控制权',
      cardIntegrity: {
        title: '保持卡牌完整性',
        description: '我们的AI只修改艺术图，同时完美保持卡牌框架、文本、法术力符号和布局不变。',
      },
      creativity: {
        title: '无限创意',
        description: '用您能想象的任何主题或风格改造您的卡牌 - 从奇幻到科幻，从照片级写实到抽象风格。',
      },
      instantResults: {
        title: '即时结果',
        description: '无需设计技能，几秒钟内生成自定义艺术图。只需描述您想看到的效果。',
      },
      saveCreations: {
        title: '保存您的创作',
        description: '所有您的AI生成卡牌都会保存到您的账户中，您可以随时从仪表板访问。',
      },
      printAnytime: {
        title: '随时打印',
        description: '随时将您的自定义卡牌添加到代理列表，并与您收藏的其余卡牌一起打印。',
      },
    },
    credits: {
      title: 'AI生成点数',
      subtitle: '通过强大、经济且易用的AI生成点数，自定义和改造您的万智牌代理卡。',
      howItWorks: '点数如何运作',
      step1: {
        number: '1',
        title: '购买点数',
        description: '选择符合您创意需求和预算的套餐',
      },
      step2: {
        number: '2',
        title: '生成自定义艺术图',
        description: '每生成一次万智牌代理卡使用1点',
      },
      step3: {
        number: '3',
        title: '跟踪您的使用情况',
        description: '在您的账户仪表板中查看并随时购买更多点数',
      },
      proAdvantage: {
        title: 'Pro会员优势',
        description: 'Pro会员每月获得5点AI生成点数作为订阅福利。加入Pro以最大化您的创意潜力！',
      },
      purchaseButton: '立即购买点数',
      unlockProButton: '解锁Pro会员',
      packages: {
        title: '点数套餐',
        small: {
          name: '小型套餐',
          credits: '5',
          price: '2.99',
          value: '$0.60/点',
        },
        medium: {
          name: '中型套餐',
          credits: '15',
          price: '7.99',
          value: '$0.53/点',
          popular: '热门',
        },
        large: {
          name: '大型套餐',
          credits: '30',
          price: '13.99',
          value: '$0.47/点',
        },
        createDesigns: '创建{{credits}}个独特的卡牌设计',
      },
    },
  },
};

export default translations;
